import ScrollAdapter from 'owa-scroll-adapter/lib/ScrollAdapter';
import getScrollTopForCursor from './utils/getScrollTopForCursor';
import { isBrowserEdge } from 'owa-user-agent/lib/userAgent';
var DockingPluginBase = /** @class */ (function () {
    function DockingPluginBase(viewState) {
        this.viewState = viewState;
        this.isEdge = isBrowserEdge();
        this.scrollAdapter = new ScrollAdapter();
    }
    DockingPluginBase.prototype.initialize = function (editor) {
        this.editor = editor;
        this.scrollAdapter.addScrollContainerChangedListener(this.onScrollContainerChanged);
    };
    DockingPluginBase.prototype.onPluginEvent = function (event) {
        if (event.eventType == 2 /* KeyUp */ ||
            event.eventType == 1 /* KeyPress */ ||
            (event.eventType == 6 /* ContentChanged */ &&
                event.source != 'SetContent')) {
            if (this.isEdge && this.onCursorTopChanged) {
                this.onCursorTopChanged();
            }
            if (this.viewState.isTopDocking || this.viewState.isBottomDocking) {
                this.scrollCursorIntoView();
            }
        }
    };
    DockingPluginBase.prototype.scrollCursorIntoView = function () {
        var _this = this;
        if (!this.scrollThrottlingJob) {
            this.scrollThrottlingJob = window.setTimeout(function () {
                _this.scrollThrottlingJob = 0;
                var scrollContainer = _this.scrollAdapter.getScrollContainer();
                if (scrollContainer && _this.editor) {
                    var containerRect = scrollContainer.getBoundingClientRect();
                    var cursorRect = _this.editor.getCursorRect();
                    // editor.getCursorRect could return a null, make sure to check it before proceeding
                    if (containerRect && cursorRect) {
                        scrollContainer.scrollTop = getScrollTopForCursor(_this.viewState, scrollContainer.scrollTop, containerRect.top, containerRect.bottom, cursorRect.top, cursorRect.bottom);
                    }
                }
            }, 100);
        }
    };
    DockingPluginBase.prototype.setOnCursorTopChanged = function (handler) {
        this.onCursorTopChanged = handler;
    };
    DockingPluginBase.prototype.setDockingTriggerPart = function (dockingTriggerPart) {
        this.dockingTriggerPart = dockingTriggerPart;
    };
    DockingPluginBase.prototype.setInitialVisiblePart = function (initialVisiblePart) {
        this.initialVisiblePart = initialVisiblePart;
        this.tryScrollIntoView();
    };
    DockingPluginBase.prototype.getScrollAdapter = function () {
        return this.scrollAdapter;
    };
    DockingPluginBase.prototype.dispose = function () {
        this.scrollAdapter.removeScrollContainerChangedListener(this.onScrollContainerChanged);
        this.editor = null;
    };
    /**
     * Used when the content size where compose is hosted is changed
     * Most likely a compensate scroll is needed to ensure compose is in reasonable position in the scroll region
     * delta: the amount of size increased or decreased. 0 indicates no change.
     * sourceElement: the source of change. Also the field of interest that needs to be brought to view port
     * if there is no need to bring a source Element to view port, caller should pass in a null
     */
    DockingPluginBase.prototype.onContentSizeChanged = function (delta, sourceElement) {
        if (sourceElement === void 0) { sourceElement = null; }
        var scrollContainer = this.scrollAdapter.getScrollContainer();
        if (!scrollContainer || delta == 0) {
            // scrollContainer is null, or there isn't really change
            return;
        }
        // Start with a min scrollTop of 0, and max allowed scroll top
        var minScrollTop = 0;
        var maxScrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;
        // Calcuate the scroll top that is needed to keep compose in its original position
        var newScrollTop = scrollContainer.scrollTop + delta;
        newScrollTop = Math.max(minScrollTop, newScrollTop);
        newScrollTop = Math.min(newScrollTop, maxScrollTop);
        // sourceElement is not only the source where the content size is changed, but also
        // the field of interest which we need to ensure it is brought to view port
        // calculate the min & max scroll top required to bring source element to view port
        if (sourceElement) {
            minScrollTop = Math.max(minScrollTop, sourceElement.offsetTop + sourceElement.clientHeight - scrollContainer.clientHeight);
            maxScrollTop = Math.min(maxScrollTop, sourceElement.offsetTop);
        }
        // Now check if newScrollTop can fall in the scope and use it if so
        // Otherwise scroll to make sure sourceElemen is brought to view port
        if (newScrollTop != scrollContainer.scrollTop &&
            (newScrollTop >= minScrollTop && newScrollTop <= maxScrollTop)) {
            scrollContainer.scrollTop = newScrollTop;
        }
        else {
            // When a scroll down is needed, pick the minScrollTop
            // Otherwise (scroll up), pick the maxScrollTop
            var originalScrollTop = scrollContainer.scrollTop;
            if (originalScrollTop < minScrollTop) {
                scrollContainer.scrollTop = minScrollTop;
            }
            else if (originalScrollTop > maxScrollTop) {
                scrollContainer.scrollTop = maxScrollTop;
            }
        }
    };
    DockingPluginBase.prototype.getVisibleAreaInfo = function () {
        var scrollContainer = this.scrollAdapter.getScrollContainer();
        var top = 0;
        var bottom = 0;
        var visibleBodyHeight;
        var visibleBodyWidth;
        if (scrollContainer &&
            scrollContainer.scrollHeight !== scrollContainer.clientHeight &&
            this.dockingTriggerPart) {
            var scrollTop = scrollContainer.scrollTop;
            var clientHeight = scrollContainer.clientHeight;
            var offsetTop = this.dockingTriggerPart.offsetTop;
            var offsetHeight = this.dockingTriggerPart.offsetHeight;
            top = this.viewState.isTopDocking
                ? scrollTop + this.viewState.topDockingHeight + 1 - offsetTop
                : 0;
            bottom = this.viewState.isBottomDocking
                ? offsetTop +
                    offsetHeight -
                    scrollTop -
                    clientHeight +
                    this.viewState.bottomDockingHeight
                : 0;
        }
        if (this.dockingTriggerPart) {
            visibleBodyHeight = this.dockingTriggerPart.offsetHeight - top - bottom;
        }
        visibleBodyWidth = this.viewState.dockingWidth;
        return {
            top: top,
            bottom: bottom,
            visibleBodyHeight: visibleBodyHeight,
            visibleBodyWidth: visibleBodyWidth,
        };
    };
    DockingPluginBase.prototype.tryScrollIntoView = function () {
        var scrollContainer = this.scrollAdapter.getScrollContainer();
        if (this.editor && scrollContainer && this.initialVisiblePart) {
            var viewport = scrollContainer.getBoundingClientRect();
            var inlineComposeRect = this.initialVisiblePart.getBoundingClientRect();
            if (inlineComposeRect.bottom > viewport.bottom) {
                scrollContainer.scrollTop += inlineComposeRect.bottom - viewport.bottom;
            }
            if (inlineComposeRect.top < viewport.top) {
                scrollContainer.scrollTop += inlineComposeRect.top - viewport.top;
            }
        }
    };
    return DockingPluginBase;
}());
export default DockingPluginBase;
//# sourceMappingURL=DockingPluginBase.js.map